import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Activities = () => {
  const [searchParams] = useSearchParams();
  const user_id = searchParams.get('user_id');
  const { fetchWithAuth } = useAuth();
  
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const limit = 20;

  useEffect(() => {
    fetchActivities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, user_id]);

  const fetchActivities = async () => {
    setLoading(true);
    try {
      const url = user_id 
        ? `/api/activities?page=${page}&limit=${limit}&user_id=${user_id}`
        : `/api/activities?page=${page}&limit=${limit}`;
      
      const response = await fetchWithAuth(url);
      if (!response.ok) throw new Error('Failed to fetch activities');
      const data = await response.json();
      setActivities(data.data);
      setTotal(data.total);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const totalPages = Math.ceil(total / limit);

  if (loading && activities.length === 0) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div>
      <h1 style={{ fontSize: '32px', fontWeight: '700', marginBottom: '24px' }}>
        Fitness Activities {user_id && `- User ${user_id}`}
      </h1>

      {user_id && (
        <div style={{ marginBottom: '16px' }}>
          <Link to="/activities" className="link">← View All Activities</Link>
        </div>
      )}

      <div className="card">
        <div style={{ marginBottom: '16px', color: '#666' }}>
          {total} total records
        </div>

        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>User</th>
                <th>Activity Name</th>
                <th>Duration</th>
                <th>Calories Burned</th>
                <th>Date</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {activities.map((activity) => (
                <tr key={activity.id}>
                  <td>{activity.id}</td>
                  <td>
                    <Link to={`/users/${activity.user_id}`} className="link">
                      {activity.user_name || `User ${activity.user_id}`}
                    </Link>
                  </td>
                  <td><strong>{activity.name || activity.activity_name || 'N/A'}</strong></td>
                  <td>{activity.duration_minutes ? `${activity.duration_minutes} min` : 'N/A'}</td>
                  <td>{activity.calories_burned ? `${Math.round(activity.calories_burned)} kcal` : 'N/A'}</td>
                  <td>{activity.date || 'N/A'}</td>
                  <td>{formatDate(activity.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="pagination">
          <button
            className="btn btn-secondary"
            onClick={() => setPage(page - 1)}
            disabled={page === 1}
          >
            Previous
          </button>
          <span className="page-info">
            Page {page} of {totalPages}
          </span>
          <button
            className="btn btn-secondary"
            onClick={() => setPage(page + 1)}
            disabled={page >= totalPages}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Activities;


